import { Card, CardMedia as MuiCardMedia, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import ChipBase from '@/components/ui/Chip/Chip';

export const TileWrapper = styled(Card)(({ theme }) => ({
  height: '100%',
  position: 'relative',
  borderRadius: theme.shape.borderRadiusLarge,
  display: 'flex',
  flexDirection: 'column',
}));

export const CardMedia = styled(MuiCardMedia)(({ theme }) => ({
  background: theme.palette.grayscale[100],
}));

export const Chip = styled(ChipBase, {
  shouldForwardProp: prop => prop !== 'backgroundColor',
})(({ backgroundColor }) => ({
  backgroundColor: alpha(backgroundColor, 0.15),
}));

export const Heading = styled(Typography)(() => ({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  display: '-webkit-box !important',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical',
  whiteSpace: 'normal',
}));

export const ExcerptContent = styled('div')(({ theme }) => ({
  flex: 1,
  p: {
    ...theme.typography.body1Redesign,
    color: theme.palette.text.secondary,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: '-webkit-box !important',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
    whiteSpace: 'normal',
    minHeight: 70,
    marginTop: theme.spacing(1),
  },
}));
